/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ConfluenceAdminAnnouncementBannerStatusType {
  PUBLISHED = "PUBLISHED",
  SAVED = "SAVED",
  SCHEDULED = "SCHEDULED",
}

export enum ConfluenceAdminAnnouncementBannerVisibilityType {
  ALL = "ALL",
  AUTHORIZED = "AUTHORIZED",
}

export interface ConfluenceUpdateAdminAnnouncementBannerInput {
  appearance?: string | null;
  content?: string | null;
  id: string;
  isDismissible?: boolean | null;
  status?: ConfluenceAdminAnnouncementBannerStatusType | null;
  visibility?: ConfluenceAdminAnnouncementBannerVisibilityType | null;
  title?: string | null;
  scheduledEndTime?: string | null;
  scheduledStartTime?: string | null;
  scheduledTimeZone?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAdminAnnouncementBannerMutation
// ====================================================

export interface UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_adminAnnouncementBannerSetting {
  appearance: string;
  content: string;
  id: string;
  isDismissible: boolean;
  status: ConfluenceAdminAnnouncementBannerStatusType;
  title: string | null;
  visibility: ConfluenceAdminAnnouncementBannerVisibilityType;
  scheduledEndTime: string | null;
  scheduledStartTime: string | null;
  scheduledTimeZone: string | null;
}

export interface UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors_extensions_GenericMutationErrorExtension {
  errorType: string | null;
}

export interface UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors_extensions_AdminAnnouncementBannerMutationErrorExtension_adminAnnouncementBannerList {
  id: string;
  title: string | null;
  scheduledStartTime: string | null;
  scheduledEndTime: string | null;
}

export interface UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors_extensions_AdminAnnouncementBannerMutationErrorExtension {
  errorType: string | null;
  adminAnnouncementBannerList: (UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors_extensions_AdminAnnouncementBannerMutationErrorExtension_adminAnnouncementBannerList | null)[];
}

export type UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors_extensions = UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors_extensions_GenericMutationErrorExtension | UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors_extensions_AdminAnnouncementBannerMutationErrorExtension;

export interface UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors {
  message: string | null;
  extensions: (UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors_extensions | null)[] | null;
}

export interface UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner {
  adminAnnouncementBannerSetting: UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_adminAnnouncementBannerSetting | null;
  errors: UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_errors[] | null;
  success: boolean;
}

export interface UpdateAdminAnnouncementBannerMutation {
  updateAdminAnnouncementBanner: UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner | null;
}

export interface UpdateAdminAnnouncementBannerMutationVariables {
  announcementBanner: ConfluenceUpdateAdminAnnouncementBannerInput;
}
